import type { RolesType } from "@auth/context/Auth.provider";
import React, { useContext } from "react";

interface AuthProps {
  initialized?: boolean;
  errorKeycloak?: boolean;
  authenticated?: boolean;
  token?: string;
  idToken?: string;
  userId?: string;
  userDisplayName: string;
  logout: () => void;
  login?: (realm: "Ambev" | "Third") => void;
  hasSomeResourceRole: (...role: RolesType[]) => boolean;
}

const AuthContext = React.createContext<AuthProps>(null);

export const useAuthContext = () => useContext(AuthContext);

export default AuthContext;
